export const brandStyles = {
  staysure: {
    gap: "lg:gap-x-[38px]",
    paddingLeft: "lg:pl-[19px]",
    marginLeft: "lg:ml-[-19px]",
    dividerColor: "#DCDCDC",
  },
  avanti: {
    gap: "lg:gap-x-[30px]",
    paddingLeft: "lg:pl-[10px]",
    marginLeft: "lg:ml-[-12px]",
    dividerColor: "#DCD8D3",
  },
};

export function openInNewTab(url: string | undefined) {
  if (!url) return;
  window.open(url, "_blank", "noreferrer");
}
